import { UserLicense } from "client/Api/FeaturePackages/featurePackageManagement";
import {
	CheckboxGroup,
	CheckboxGroupItem,
	Form,
	FormItem,
	Toolbar
} from "client/Components";
import { FilterValueState } from "client/Hooks";
import { getNumericEnumValues } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useState } from "react";
import { getUserLicenseName } from "../FeaturePackages/misc";

export type UserLicenseFilterFormProps = {
	filterable: FilterValueState<readonly UserLicense[]>;
	onClose(): void;
};

export const UserLicenseFilterForm = (props: UserLicenseFilterFormProps): ReactElement => {
	const {
		filterable,
		onClose
	} = props;

	const {
		value,
		setValue
	} = filterable;

	const [selectedValues, setSelectedValues] = useState<readonly UserLicense[]>(value);

	const filterHandler = (): void => {
		setValue(selectedValues);
		onClose();
	};

	const clearHandler = (): void => {
		setSelectedValues([]);
		setValue([]);
	};

	return (
		<Form onSubmit={filterHandler}>
			<FormItem
				label={localize("_GridFilterMenuTitle")}
				isForGroup
			>
				<CheckboxGroup
					value={selectedValues}
					onChange={setSelectedValues}
					options={useLicenseFilterOptions}
					trackingId="module-filter-selection"
				/>
			</FormItem>
			<div>
				<Toolbar horizontalAlignment="right">
					<Toolbar.Button
						kind="primary"
						text={localize("_Filter")}
						onClick={filterHandler}
						trackingId="filter-button"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Clear")}
						onClick={clearHandler}
						trackingId="clear-button"
					/>
				</Toolbar>
			</div>
		</Form>
	);
};
UserLicenseFilterForm.displayName = "UserLicenseFilterForm";

const useLicenseFilterOptions: readonly CheckboxGroupItem<UserLicense>[] = [
	...getNumericEnumValues(UserLicense)
		.map((x): CheckboxGroupItem<UserLicense> => ({
			text: getUserLicenseName(x),
			value: x
		}))
];
